export default __webpack_public_path__ + "static/slider-4-cdd8c7185899793b5c1d5e0586c5e760.jpg";